var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditpost({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.20351 8.40805L8.40262 1.17676C8.61568 0.962212 8.8688 0.791979 9.14745 0.675837C9.42611 0.559695 9.72482 0.5 10.0265 0.5C10.3282 0.5 10.627 0.559695 10.9056 0.675837C11.1843 0.791979 11.4374 0.962212 11.6504 1.17676L12.8262 2.35775C13.0398 2.57177 13.2092 2.8261 13.3249 3.106C13.4405 3.3859 13.5 3.68593 13.5 3.98897C13.5 4.29201 13.4405 4.59203 13.3249 4.87193C13.2092 5.15183 13.0398 5.40605 12.8262 5.62007L5.58853 12.8901C5.39471 13.0841 5.16471 13.2379 4.91169 13.3426C4.65868 13.4472 4.38763 13.5007 4.11401 13.5H0.5L0.586733 9.84086C0.604408 9.30209 0.824808 8.79 1.20351 8.40805V8.40805Z",
    stroke: "#200E32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.30273 2.29974L11.707 6.71398",
    stroke: "#200E32",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditpost);
export default __webpack_public_path__ + "static/media/editpost.97cc5d8702d663de45a5102d4a9f030b.svg";
export { ForwardRef as ReactComponent };